<app-table
  [columns]="personColumns"
  [data]="persons"
  [showSearch]="true"
  [searchPlacehoder]="'COMMON.SEARCH' | translate"
  [pageSize]="10"
  [showActionButton]="true"
  actionButtonIcon="add"
  [actionButtonText]="'COMMON.ADD-EMPLOYEES' | translate"
  (actionFunction)="showAddEmployeesModal()"
  (onRowClick)="navigateToEmployee($event)"
></app-table>

<dx-popup
  [width]="980"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'COMMON.ADD-EMPLOYEES' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [(visible)]="showAddPersonModal"
  [showCloseButton]="true"
>
  <div *dxTemplate="let data of 'content'">
    <app-attendees-list
      [disableTrainingGroupFilter]="true"
      [(selectedPersons)]="selectedPersons"
      [excludePersonIds]="personIds"
    ></app-attendees-list>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="before"
    [options]="{
      stylingMode: 'outlined',
      text: 'COMMON.CLOSE' | translate,
      onClick: closeAddPersonModal
    }"
  ></dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
      stylingMode: 'contained',
      text: 'COMMON.ADD' | translate,
      onClick: onAddPersons
    }"
  ></dxi-popup-toolbar-item>
</dx-popup>

<app-confirmation-dialog
  [height]="'auto'"
  [(showModal)]="showDeletePersonModal"
  (submit)="deletePersonFromTrainingGroup()"
  [options]="modalDeletePersonConfirmationOptions"
></app-confirmation-dialog>